import React, { ChangeEvent, useEffect, useState } from "react";
import { FieldType } from "../../../services/helpers/types";
import {
  generateUnit,
  stringToUnit,
} from "../../molecules/DoctorsReport/helpers";
import { Input } from "@mui/material";
import { useTranslation } from "react-i18next";

interface NumberNumberFieldProps {
  field: FieldType;
  value?: string;
  onChange: (value?: string) => void;
}

const NumberNumberField = (props: NumberNumberFieldProps) => {
  const { field, value = "", onChange } = props;

  const { t } = useTranslation();

  const [unit1Raw, unit2Raw] = field.unit ? field.unit.split(",") : ["", ""];

  const [firstValue, setFirstValue] = useState<string>(value);
  const [secondValue, setSecondValue] = useState<string>(value);
  const [firstUnit, setFirstUnit] = useState<string | undefined>(unit1Raw);
  const [secondUnit, setSecondUnit] = useState<string | undefined>(unit2Raw);
  useEffect(() => {
    setFirstValue(field.defaultValue);
    setSecondValue(field.defaultValue);
  }, [field.defaultValue]);

  useEffect(() => {
    if (value.includes(";")) {
      const [value1, value2] = value.split(";");
      setFirstValue(value1);
      setSecondValue(value2);
    }
    const unit1 = generateUnit(
      t,
      stringToUnit(unit1Raw),
      firstValue === "" ? "0" : firstValue
    );
    const unit2 = generateUnit(
      t,
      stringToUnit(unit2Raw),
      secondValue === "" ? "0" : secondValue
    );
    setFirstUnit(unit1);
    setSecondUnit(unit2);
  }, [firstValue, secondValue, t, unit1Raw, unit2Raw, value]);

  const commaSeparator = {
    name: "comma",
    regex: /^\d+(,\d{0,10})?$/,
  };
  const dotSeparator = {
    name: "period",
    regex: /^\d+(\.\d{0,10})?$/,
  };

  const handleFirstInputChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const currentValue = event.target.value;
    if (currentValue === "") {
      setFirstValue(currentValue);
      onChange(`;${secondValue}`);
    }
    if (
      commaSeparator.regex.test(currentValue) ||
      dotSeparator.regex.test(currentValue)
    ) {
      setFirstValue(currentValue);
      onChange(`${currentValue};${secondValue}`);
    }
  };

  const handleSecondInputChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const currentValue = event.target.value;
    if (currentValue === "") {
      setSecondValue(currentValue);
      onChange(`${firstValue};`);
    }
    if (
      commaSeparator.regex.test(currentValue) ||
      dotSeparator.regex.test(currentValue)
    ) {
      setSecondValue(currentValue);
      onChange(`${firstValue};${currentValue}`);
    }
  };

  return (
    <div className="dui-number-number-field">
      <div className="dui-number-field">
        <Input
          className="dui-number-field-inner"
          onChange={handleFirstInputChange}
          placeholder={field.placeholder}
          value={firstValue}
          endAdornment={
            <div className="dui-number-field-unit">{firstUnit}</div>
          }
        />
        <Input
          className="dui-number-field-inner"
          onChange={handleSecondInputChange}
          placeholder={field.placeholder}
          value={secondValue}
          endAdornment={
            <div className="dui-number-field-unit">{secondUnit}</div>
          }
        />
      </div>
    </div>
  );
};

export default NumberNumberField;
